import React from "react";
// import "./payments.css";
import RecentPayments from "../RecentPayments/RecentPayments";
import CustomComponent from "../RecentPayments/CustomComponent-Original";

function Payments() {
  return (
    // <div className="container">
    //   <p className="text-xl">Payments</p>

    //   <div className="">
    //     <div>
    //       <RecentPayments />
    //     </div>
    //   </div>
    // </div>

    <div className="bg-gray-50 min-h-screen">
      {/* <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Payments</h1>
      </div> */}

      <div className="bg-white rounded-lg shadow-sm p-6">
        <CustomComponent
          displayAll={true}
          showDownloadButton={true}
          limitRows={false}
        />
      </div>
    </div>
  );
}

export default Payments;
